/** @format */

import React, { FunctionComponent } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import { SetDocumentFn } from 'src/utils'
import Cookie from 'js-cookie'

export const wordLink = [
  { name: _$('产品介绍'), link: '6474' },
  { name: _$('云监控快速入门'), link: '28122' },
  { name: _$('告警服务设置'), link: '31' },
  { name: _$('自定义面板'), link: '6267' },
  { name: _$('自定义监控'), link: '41371', hide: 'en' }
]

const ProductDy: FunctionComponent<{ className?: string }> = ({ className }) => {
  const lang = Cookie.get('ksc_lang')
  return (
    <div className={className}>
      <Card
        style={{ height: '100%' }}
        slotTitle={<h4>{_$('帮助文档')}</h4>}
        slotExtra={
          <a
            target="_blank"
            href={
              lang === 'zh'
                ? 'https://docs.ksyun.com/products/2'
                : 'https://endocs.ksyun.com/products/2'
            }
            rel="noreferrer"
          >
            {_$('更多')}
          </a>
        }
      >
        <ul>
          {wordLink
            .filter(item => item.hide !== lang)
            .map(item => (
              <li key={item.name}>
                <a onClick={() => SetDocumentFn(item.link)}>{_$(item.name)}</a>
              </li>
            ))}
        </ul>
      </Card>
    </div>
  )
}

export default styled(ProductDy)`
  width: calc(35% - 16px);
  margin-left: 16px;
  ul li {
    height: 40px;
    line-height: 40px;
    padding-left: 24px;
    position: relative;
    font-size: 12px;
    color: #4c4c4c;
  }
`
